import React, { useMemo } from 'react';
import { useFrequentlyBoughtTogether } from 'react-instantsearch-core';
import Loading from 'components/commercetools-ui/atoms/loading';
import { P2Badge } from '../product-list-algolia/types';
import ProductTileSlider from '../../ProductTile-Slider';

function BoughtTogetherRecommendation({
  objectIDs,
  title,
  p1BadgeData,
  p2BadgeData,
  queryParameters,
}: {
  objectIDs: string[];
  title?: string;
  p1BadgeData: any;
  p2BadgeData: P2Badge[];
  queryParameters?: string;
}) {
  const memoizedObjectIDs = useMemo(() => objectIDs, [objectIDs.join(',')]);

  return (
    <AlgoliaRecommendationCarouselWrapper
      objectIDs={memoizedObjectIDs}
      title={title}
      p1BadgeData={p1BadgeData}
      p2BadgeData={p2BadgeData}
      queryParameters={queryParameters}
    />
  );
}

function AlgoliaRecommendationCarouselWrapperComponent({
  objectIDs,
  title,
  p1BadgeData,
  p2BadgeData,
  queryParameters,
}: {
  objectIDs: string[];
  title?: string;
  p1BadgeData: any;
  p2BadgeData: P2Badge[];
  queryParameters?: string;
}) {
  let raw = queryParameters;
  if (raw?.startsWith('"') && raw?.endsWith('"')) {
    raw = raw?.slice(1, -1);
  }

  const cleanedFilter = raw?.replace(/\\"/g, '"');
  const result =
    useFrequentlyBoughtTogether({
      objectIDs,
      queryParameters: {
        filters: cleanedFilter,
      },
    }) || {};

  const items = result?.items;
  return (
    <>
      {/* <AlgoliaRecommendationCarousel title={title || 'Frequently Bought Together'} items={items} /> */}
      {items && (
        <ProductTileSlider
          title={title || 'Trending Items'}
          p1BadgeData={p1BadgeData}
          p2BadgeData={p2BadgeData}
          items={items}
        />
      )}
    </>
  );
}

const AlgoliaRecommendationCarouselWrapper = React.memo(AlgoliaRecommendationCarouselWrapperComponent);
AlgoliaRecommendationCarouselWrapper.displayName = 'AlgoliaRecommendationCarouselWrapper';

export default BoughtTogetherRecommendation;
